/**
 * Default configuration for dialogs
 */
export const dialogConfig = {
  closeOnEscKey: true,
  closeOnBackdropClick: true,
};
